var map = {
	"./Dashboard": [
		2632,
		807
	],
	"./Dashboard.vue": [
		2632,
		807
	],
	"./Error": [
		6621,
		193
	],
	"./Error.vue": [
		6621,
		193
	],
	"./Instructions": [
		4240,
		464
	],
	"./Instructions.vue": [
		4240,
		464
	],
	"./Login": [
		4228,
		500
	],
	"./Login.vue": [
		4228,
		500
	],
	"./Notifications": [
		812,
		935
	],
	"./Notifications.vue": [
		812,
		935
	],
	"./OrderView": [
		5827,
		792
	],
	"./OrderView.vue": [
		5827,
		792
	],
	"./Orders": [
		4618
	],
	"./Orders.vue": [
		4618
	],
	"./Organisations": [
		4293,
		642
	],
	"./Organisations.vue": [
		4293,
		642
	],
	"./UserProfile": [
		9932,
		543
	],
	"./UserProfile.vue": [
		9932,
		543
	],
	"./Users": [
		4005,
		131
	],
	"./Users.vue": [
		4005,
		131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9555;
module.exports = webpackAsyncContext;